/**
 *微博融合详情页 
 */
"use strict";
angular.module('wbPreviewRouterModule', [])
    .config(["$stateProvider", function($stateProvider) {
        $stateProvider
            .state("wbPreview", {
                url: "/wbpreview?wbmetadataid&wbplatform&wbchannelid&isawaitrevise&fromsearch&fromversiontime",//isawaitrevise->是否修订
                views: {
                    "": {
                        templateUrl: "./editingCenter/weibo/preview/wbPreview_tpl.html",
                        controller: "wbPreviewCtrl"
                    }
                }
            });
    }]);